module.exports = __webpack_public_path__ + "static/media/se.ee9cde49.svg";